import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./StudentHomePage.css"; // Import the CSS file
import { Student_Get_One_From_MongoDB } from "../../api/Student_Get_One_From_MongoDB";
import { StudentuseAuth } from "../../security/StudentUseAuth";
import WEFIntro from "./components/WEFIntro";
import WEFProgressBox from "./components/WEFProgressBox";
import SEFIntro from "./components/SEFIntro";
import SEFProgressBox from "./components/SEFProgressBox";
import { Arr_SEFPages } from "../../../arrays/SEF/Arr_SEFPages";
import SEFArrivalDeparture from "./components/SEFArrivalDeparture";

const HomePageStudent = () => {
  const { logoutStudent } = StudentuseAuth();

  const [Attendee, setAttendee] = useState({
    _id: "",
    BasicInfo: {
      First_Name: "Loading...",
      Last_Name: "Loading...",
      ProgrammeTitle: "Loading...",
      ProgrammeDate: "Loading...",
      ProgrammeVarient: "Loading...",
    },
    SEFInfo: {},
  });

  useEffect(() => {
    const fetchData = () => {
      Student_Get_One_From_MongoDB(
        "Registers_2025",
        "All",
        localStorage.getItem("Student_id"),
        setAttendee,
        logoutStudent
      );
    };

    fetchData(); // Initial fetch
    const intervalId = setInterval(fetchData, 40000); // Fetch every 10 seconds
    return () => clearInterval(intervalId); // Cleanup interval on component unmount
  }, []);

  let ProgrammeType = "Loading";
  if (Attendee.BasicInfo?.ProgrammeTitle.toLowerCase().includes("summer")) {
    ProgrammeType = "SXP";
  } else if (
    Attendee.BasicInfo?.ProgrammeTitle.toLowerCase().includes("weekend")
  ) {
    ProgrammeType = "Weekend";
  }

  let ProgrammeVarient = "";
  if (Attendee.BasicInfo?.ProgrammeVarient) {
    ProgrammeVarient = Attendee.BasicInfo.ProgrammeVarient;
  }

  //---------------------------WEF--------------------------------

  const WEFprogressData = [
    {
      label: "Basic Info",
      Prop: "BasicInfo",
      link: "ViewBasicInfo",
    },
    {
      label: "General Info",
      Prop: "GeneralInfo",
      link: "ViewGeneralInfo",
    },
    {
      label: "Emergency Medical Info",
      Prop: "EmergancyMedicalInfo",
      link: "ViewEmergancyMedicalInfo",
    },
    {
      label: "SEND Info",
      Prop: "SENDInfo",
      link: "ViewSENDInfo",
    },

    {
      label: "Contact Info",
      Prop: "ContactInfo",
      link: "ViewContactInfo",
    },
    {
      label: "Declarations",
      Prop: "PermissionsInfo",
      link: "ViewPermissionsInfo",
    },
  ];

  let WEFprogressData_NotDeclarations = WEFprogressData.filter(
    (item) => item.label !== "Declarations"
  );

  function allWEFComplete_NotDeclarations() {
    return WEFprogressData_NotDeclarations.every(
      (item) =>
        Attendee &&
        Attendee.SEFProgress &&
        Attendee.SEFProgress[item.Prop] &&
        Attendee.SEFProgress[item.Prop] === "Complete"
    );
  }

  const allWEFComplete = WEFprogressData.every(
    (item) =>
      Attendee &&
      Attendee.SEFProgress &&
      Attendee.SEFProgress[item.Prop] &&
      Attendee.SEFProgress[item.Prop] === "Complete"
  );

  //---------------------------SEF--------------------------------

  //const allSEFComplete = true;
  const allSEFComplete = Arr_SEFPages.every(
    (item) =>
      Attendee &&
      Attendee.SEFProgress &&
      Attendee.SEFProgress[item.Prop] &&
      Attendee.SEFProgress[item.Prop] === "Complete"
  );

  //---------------------------RETURN--------------------------------

  return (
    <div className="homepage-container">
      <img
        src={`${process.env.PUBLIC_URL}/InvestINBannerLogo.png`}
        alt="InvestIN Banner Logo"
        style={{ maxWidth: "30%", height: "auto" }}
      />
      {ProgrammeType === "Weekend" ? (
        <>
          <WEFIntro Attendee={Attendee} allWEFComplete={allWEFComplete} />
          <WEFProgressBox
            Attendee={Attendee}
            WEFprogressData={WEFprogressData}
            allWEFComplete_NotDeclarations={allWEFComplete_NotDeclarations}
          />
        </>
      ) : (
        <></>
      )}
      {ProgrammeType === "SXP" ? (
        <>
          <SEFIntro Attendee={Attendee} allSEFComplete={allSEFComplete} />
          {ProgrammeVarient &&
          ProgrammeVarient.toLowerCase().includes("accom") ? (
            <SEFArrivalDeparture Attendee={Attendee} />
          ) : (
            <></>
          )}

          <SEFProgressBox
            Attendee={Attendee}
            setAttendee={setAttendee}
            Arr_SEFPages={Arr_SEFPages}
          />
        </>
      ) : (
        <></>
      )}
      {ProgrammeType === "Loading" ? (
        <>
          <div className="welcome-message">
            <h1 className={window.innerWidth <= 768 ? "mobile-heading" : ""}>
              Loading...
            </h1>
          </div>
        </>
      ) : (
        <></>
      )}
      <br></br>
      <br></br>
      <br></br>
      <br></br>
    </div>
  );
};

export default HomePageStudent;
